export default __webpack_public_path__ + "static/ely-5-0535cb16189360e6c5b796a97b7cffb2.jpg";